import { FormControl } from '../BaseVM';
export class CheckBoxVM extends FormControl {
}
